import { LegacyMyVehiclesPanel } from "@/components/organisms/Vehicles/LegacyMyVehicles/LegacyMyVehiclesPanel";

export const LegacyMyVehicles = () => {
  return <LegacyMyVehiclesPanel />;
};
